
























import { Component, Prop, Vue } from 'vue-property-decorator'

// Package
import * as DownloadCsv from 'vue-json-csv'

// Interface
import { ITimelineCSVExport } from '@/_interfaces'

@Component({
  components: { DownloadCsv },
})
export default class ExportCSVButtons extends Vue {
  @Prop()
  selectedSlot!: any

  @Prop()
  csvInfo!: ITimelineCSVExport

  get isDisable() {
    return !this.csvInfo.csvValues.length || !this.csvInfo.isCSVAlready
  }
}
